var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from 'react';
import { useFormContext } from 'react-hook-form';
import { useGetSpaceByIdForDraftEventMeetingServicePermissionQuery } from '../../generated/graphql';
import { useUserPermissions } from '../hooks/useUserPermissions';
import { useSafeFormData, ComposerMode, } from '../types/index';
import { useIsSuggestedSpacesEnabled } from '../hooks/useIsSuggestedSpacesEnabled';
import { useEventApi } from '../hooks/useEvent/useEventApi';
import { useConfig } from '../context/ConfigContext';
import { defaultUseGetLocationLevelReturn, useGetLocationLevel, } from '../hooks/useLocationLevel/useGetLocationLevel';
var defaultEventComposerGlobalContextValue = __assign({ timezone: '', timeFormat: 'h:mm a', requestOnlySpace: undefined, requestFormId: undefined, composerMode: ComposerMode.CREATE, formIsDirty: false, suggestedSpacesEnabled: false, showSuggestedSpace: false, setShowSuggestedSpace: function () { }, onError: function () { }, onTrackBufferEvent: undefined, setSpaceBookingOpen: function () { }, pendingSpaceSwap: null, setPendingSpaceSwap: function () { }, removePendingSpace: function () { }, removeSpace: function () { }, currentUser: null, currentOrg: null, hasSpacesReservePublicPermissionForCurrentTenant: false }, defaultUseGetLocationLevelReturn);
var EventComposerGlobalContext = createContext(defaultEventComposerGlobalContextValue);
export var EventComposerGlobalProvider = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var children = _a.children, composerMode = _a.composerMode, timezone = _a.timezone, timeFormat = _a.timeFormat, onError = _a.onError, setSpaceBookingOpen = _a.setSpaceBookingOpen, onTrackBufferEvent = _a.onTrackBufferEvent, defaultLevelId = _a.defaultLevelId;
    var suggestedSpacesEnabled = useIsSuggestedSpacesEnabled();
    var _j = __read(useState(false), 2), showSuggestedSpace = _j[0], setShowSuggestedSpace = _j[1];
    var userPermissions = useUserPermissions();
    var setValue = useFormContext().setValue;
    var _k = useFormContext(), formState = _k.formState, getValues = _k.getValues;
    var formData = useSafeFormData();
    var _l = useConfig(), environmentUrls = _l.environmentUrls, userContext = _l.userContext, tenantId = _l.tenantId, accessToken = _l.accessToken;
    /* Source of truth for location and level */
    var _m = useGetLocationLevel(defaultLevelId), locationId = _m.locationId, levelId = _m.levelId, setLocationId = _m.setLocationId, setLevelId = _m.setLevelId, locationLevelLoading = _m.loading;
    var _o = __read(useState(null), 2), pendingSpaceSwap = _o[0], setPendingSpaceSwap = _o[1];
    var removeSpaceInvitee = useEventApi({
        onError: onError,
        apiUrl: environmentUrls.apiUrl,
        baseApiUrl: environmentUrls.baseApiUrl,
        currentOrg: userContext.currentOrg,
        tenantId: tenantId,
        accessToken: accessToken,
    }).removeSpaceInvitee;
    /* Create specific removeSpace function */
    var removeSpace = useCallback(function (spaceId, spaceInviteeId) { return __awaiter(void 0, void 0, void 0, function () {
        var currentSpaces, currentEventId, result, _a, updatedSpaces;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentSpaces = getValues('spaces');
                    if (!(currentSpaces === null || currentSpaces === void 0 ? void 0 : currentSpaces.length))
                        return [2 /*return*/];
                    if (!spaceInviteeId) return [3 /*break*/, 4];
                    currentEventId = formData === null || formData === void 0 ? void 0 : formData.eventId;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, removeSpaceInvitee(currentEventId, spaceInviteeId)];
                case 2:
                    result = _b.sent();
                    if (!result)
                        return [2 /*return*/];
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/];
                case 4:
                    updatedSpaces = currentSpaces.filter(function (space) { return space.id !== spaceId; });
                    setValue('spaces', updatedSpaces, { shouldDirty: true });
                    return [2 /*return*/];
            }
        });
    }); }, [setValue, formData === null || formData === void 0 ? void 0 : formData.eventId, removeSpaceInvitee, getValues]);
    var removePendingSpace = useCallback(function (pendingSpaceSwap) {
        var spaceId = pendingSpaceSwap.spaceId, spaceInviteeId = pendingSpaceSwap.spaceInviteeId;
        if (!spaceId && !spaceInviteeId)
            return;
        removeSpace(spaceId, spaceInviteeId).finally(function () {
            setPendingSpaceSwap(null);
        });
    }, [removeSpace]);
    var formIsDirty = useMemo(function () {
        return Object.keys(formState.dirtyFields).length > 0;
    }, [formState]);
    /* This assume the event being created/edited is only for a single space and that space is managed(request only) */
    var requestOnlySpace = ((_b = formData === null || formData === void 0 ? void 0 : formData.spaces) === null || _b === void 0 ? void 0 : _b.length) === 1 && ((_d = (_c = formData === null || formData === void 0 ? void 0 : formData.spaces) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.isManaged)
        ? (_e = formData === null || formData === void 0 ? void 0 : formData.spaces) === null || _e === void 0 ? void 0 : _e[0]
        : undefined;
    var spaceRequestFormData = 
    /* @TODO this name is misleading, this just gets the space */
    useGetSpaceByIdForDraftEventMeetingServicePermissionQuery({
        variables: { spaceId: ((_f = requestOnlySpace === null || requestOnlySpace === void 0 ? void 0 : requestOnlySpace.id) === null || _f === void 0 ? void 0 : _f.toString()) || '' },
        skip: !(requestOnlySpace === null || requestOnlySpace === void 0 ? void 0 : requestOnlySpace.id),
    }).data;
    var requestFormId = (_h = (_g = spaceRequestFormData === null || spaceRequestFormData === void 0 ? void 0 : spaceRequestFormData.getSpaceById) === null || _g === void 0 ? void 0 : _g.requestForm) === null || _h === void 0 ? void 0 : _h.id;
    var contextValue = useMemo(function () { return (__assign(__assign({}, userPermissions), { removeSpace: removeSpace, removePendingSpace: removePendingSpace, userPermissions: userPermissions, timezone: timezone, timeFormat: timeFormat, requestOnlySpace: requestOnlySpace, requestFormId: requestFormId, composerMode: composerMode, formIsDirty: formIsDirty, suggestedSpacesEnabled: suggestedSpacesEnabled, showSuggestedSpace: showSuggestedSpace, setShowSuggestedSpace: setShowSuggestedSpace, locationId: locationId, levelId: levelId, setLocationId: setLocationId, setLevelId: setLevelId, loading: locationLevelLoading, onError: onError, onTrackBufferEvent: onTrackBufferEvent, setSpaceBookingOpen: setSpaceBookingOpen, pendingSpaceSwap: pendingSpaceSwap, setPendingSpaceSwap: setPendingSpaceSwap })); }, [
        removeSpace,
        removePendingSpace,
        userPermissions,
        timezone,
        timeFormat,
        requestOnlySpace,
        requestFormId,
        composerMode,
        formIsDirty,
        suggestedSpacesEnabled,
        showSuggestedSpace,
        setShowSuggestedSpace,
        locationId,
        levelId,
        setLocationId,
        setLevelId,
        locationLevelLoading,
        onError,
        onTrackBufferEvent,
        setSpaceBookingOpen,
        pendingSpaceSwap,
        setPendingSpaceSwap,
    ]);
    return (_jsx(EventComposerGlobalContext.Provider, { value: contextValue, children: children }));
};
export var useEventComposerGlobalContext = function () {
    return useContext(EventComposerGlobalContext);
};
